"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectDropdown = void 0;
var react_1 = __importDefault(require("react"));
var react_select_1 = __importStar(require("react-select"));
var index_1 = require("../index");
var baseStyles_1 = require("./baseStyles");
var search_1 = __importDefault(require("adp-react-icons/lib/fa/search"));
var MultiSelectDropdown = /** @class */function (_super) {
  __extends(MultiSelectDropdown, _super);
  function MultiSelectDropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      selectedValues: _this.props.selectedValues || []
    };
    _this.optionCheckbox = function (checkboxProps) {
      return react_1.default.createElement("button", {
        onClick: function onClick(e) {
          return e.preventDefault();
        },
        style: baseStyles_1.baseStyle.optionCheckbox,
        key: "option-checkbox-" + checkboxProps.label
      }, react_1.default.createElement(index_1.Checkbox, __assign({}, checkboxProps.innerProps, {
        checked: _this.state.selectedValues && _this.state.selectedValues.findIndex(function (lbl) {
          return lbl.label === checkboxProps.label;
        }) > -1
      })), checkboxProps.label);
    };
    _this.ClearIndicator = function () {
      return null;
    };
    _this.Control = function (props) {
      return props.selectProps.menuIsOpen && _this.props.isSearchable !== false ? react_1.default.createElement(react_select_1.components.Control, __assign({}, props), react_1.default.createElement("div", {
        style: baseStyles_1.baseStyle.dropdownControl
      }, react_1.default.createElement("div", {
        style: baseStyles_1.baseStyle.dropdownControlValue
      }, react_1.default.createElement("div", {
        style: baseStyles_1.baseStyle.dropdownControlValueSeparated
      }, _this.state.selectedValues && _this.state.selectedValues.length > 0 ? react_1.default.createElement("div", {
        style: baseStyles_1.baseStyle.controlValue
      }, props.children[0].props.children[0]) : react_1.default.createElement("div", {
        style: baseStyles_1.baseStyle.controlPlaceholder
      }, props.selectProps.placeholder)), react_1.default.createElement("div", null, props.children[1])), react_1.default.createElement("div", {
        style: baseStyles_1.baseStyle.controlInput
      }, props.children[0].props.children[1], react_1.default.createElement(search_1.default, {
        style: baseStyles_1.baseStyle.controlInputIcon
      })))) : react_1.default.createElement(react_select_1.components.Control, __assign({}, props), props.children);
    };
    _this.CustomOption = function (_a) {
      var innerRef = _a.innerRef,
        innerProps = _a.innerProps,
        isSelected = _a.isSelected,
        label = _a.label,
        options = _a.options,
        isFocused = _a.isFocused;
      var group = false;
      options.map(function (option) {
        if (option.options) {
          group = true;
        }
      });
      return react_1.default.createElement("div", __assign({
        style: baseStyles_1.baseStyle.styledOption({
          isSelected: isSelected,
          isFocused: isFocused,
          group: group
        }),
        title: label,
        key: "chk-" + label,
        ref: innerRef
      }, innerProps), _this.optionCheckbox(__assign(__assign({}, innerProps), {
        innerRef: innerRef,
        label: label,
        isSelected: isSelected
      })));
    };
    _this.GroupHeading = function (props) {
      var selectedValues = _this.state.selectedValues ? Array.from(_this.state.selectedValues) : _this.props.selectedValues || [];
      var selectedOptions = props.selectProps.options[props.selectProps.options.findIndex(function (option) {
        return option.label === props.children;
      })].options;
      var categoryIsSelected = selectedOptions.filter(function (item) {
        return selectedValues.includes(item);
      }).length === selectedOptions.length && selectedValues.length > 0;
      var isIndeterminate = selectedOptions.length && !categoryIsSelected && selectedOptions.filter(function (option) {
        return selectedValues.includes(option);
      }).length > 0;
      var toggleCategory = function toggleCategory() {
        if (categoryIsSelected) {
          selectedOptions.forEach(function (item) {
            selectedValues.splice(selectedValues.findIndex(function (selected) {
              return selected === item;
            }), 1);
          });
          _this.setState({
            selectedValues: selectedValues
          }, function () {
            _this.props.onChange && _this.props.onChange(_this.state.selectedValues, selectedOptions);
          });
        } else {
          selectedOptions.forEach(function (item) {
            if (!selectedValues.includes(item)) {
              selectedValues.push(item);
            }
          });
          _this.setState({
            selectedValues: Array.from(new Set(selectedValues))
          }, function () {
            _this.props.onChange && _this.props.onChange(_this.state.selectedValues, selectedOptions);
          });
        }
      };
      return react_1.default.createElement("div", {
        key: "group-" + props.children
      }, react_1.default.createElement("button", {
        style: baseStyles_1.baseStyle.checkboxButton,
        onClick: function onClick(e) {
          e.preventDefault();
          toggleCategory();
        }
      }, react_1.default.createElement(index_1.Checkbox, {
        indeterminate: isIndeterminate,
        checked: categoryIsSelected || _this.state.selectedValues && _this.state.selectedValues.includes(props.children)
      }), props.children));
    };
    _this.Menu = function (props) {
      var newOptions = props.options.flatMap(function (option) {
        if (option.options) {
          return option.options;
        }
        return option;
      });
      var uneven = _this.state.selectedValues && _this.state.selectedValues.length !== newOptions.length;
      var allSelected = _this.state.selectedValues && newOptions.length === _this.state.selectedValues.length;
      var setValues = function setValues(options) {
        _this.setState({
          selectedValues: options
        }, function () {
          _this.props.onChange && _this.props.onChange(_this.state.selectedValues, options);
        });
      };
      var checkboxAction = function checkboxAction() {
        if (uneven) {
          setValues(newOptions);
        } else {
          setValues([]);
        }
      };
      return react_1.default.createElement(react_select_1.components.Menu, __assign({}, props), _this.props.selectAll && react_1.default.createElement("div", null, react_1.default.createElement("button", {
        style: baseStyles_1.baseStyle.optionCheckboxSelectAll,
        onClick: function onClick(e) {
          e.preventDefault();
          checkboxAction();
        }
      }, react_1.default.createElement(index_1.Checkbox, {
        onChange: function onChange() {
          return checkboxAction();
        },
        checked: allSelected
      }), "Select All")), props.children);
    };
    _this.MultiValue = function (props) {
      if (props && props.index === 0) {
        return react_1.default.createElement("div", {
          style: baseStyles_1.baseStyle.customMultiValueLabel,
          title: props.selectProps.value.map(function (val) {
            return val.label;
          }).valueOf()
        }, "(" + props.selectProps.value.length + ") " + (_this.props.optionTerm && _this.props.optionTerm) + " selected");
      }
      return null;
    };
    _this.MultiValueLabel = function (props) {
      return props.data ? react_1.default.createElement(react_select_1.components.MultiValueLabel, __assign({}, props), props.data && props.data.label, props && props.selectProps && props.selectProps.value[props.selectProps.value.length - 1].value === props.data.value ? '' : ',') : react_1.default.createElement(react_select_1.components.MultiValueLabel, __assign({}, props), props.children);
    };
    _this.MultiValueRemove = function () {
      return null;
    };
    _this.onBlur = function (event) {
      _this.props.onBlur && _this.props.onBlur(event);
    };
    _this.onMenuOpen = function () {
      _this.props.onMenuOpen && _this.props.onMenuOpen();
    };
    _this.onMenuClose = function () {
      _this.props.onMenuClose && _this.props.onMenuClose();
    };
    _this.onFocus = function (event) {
      _this.props.onFocus && _this.props.onFocus(event);
    };
    _this.onInputChange = function (input) {
      _this.props.onInputChange && _this.props.onInputChange(input);
    };
    _this.onKeyDown = function (event) {
      _this.props.onKeyDown && _this.props.onKeyDown(event);
    };
    _this.onMenuScrollToTop = function () {
      _this.props.onMenuScrollToTop && _this.props.onMenuScrollToTop();
    };
    _this.onMenuScrollToBottom = function () {
      _this.props.onMenuScrollToBottom && _this.props.onMenuScrollToBottom();
    };
    return _this;
  }
  MultiSelectDropdown.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      blurInputOnSelect = _a.blurInputOnSelect,
      placeholder = _a.placeholder,
      options = _a.options,
      optionTerm = _a.optionTerm,
      name = _a.name,
      id = _a.id,
      inputId = _a.inputId,
      isDisabled = _a.isDisabled,
      isLoading = _a.isLoading,
      customStyles = _a.customStyles,
      controlShouldRenderValue = _a.controlShouldRenderValue,
      maxToDisplay = _a.maxToDisplay,
      _onChange = _a.onChange,
      openMenuOnFocus = _a.openMenuOnFocus,
      openMenuOnClick = _a.openMenuOnClick,
      menuPortalTarget = _a.menuPortalTarget,
      tabIndex = _a.tabIndex,
      tabSelectsValue = _a.tabSelectsValue,
      theme = _a.theme,
      isSearchable = _a.isSearchable,
      minMenuHeight = _a.minMenuHeight,
      maxMenuHeight = _a.maxMenuHeight,
      menuPlacement = _a.menuPlacement,
      menuPosition = _a.menuPosition,
      menuShouldBlockScroll = _a.menuShouldBlockScroll,
      noOptionsMessage = _a.noOptionsMessage;
    var styles = Object.assign(baseStyles_1.baseStyle, customStyles);
    var selectConfig = {
      Control: this.Control,
      GroupHeading: this.GroupHeading,
      ClearIndicator: this.ClearIndicator,
      MultiValueRemove: this.MultiValueRemove,
      Option: this.CustomOption,
      MultiValueLabel: this.MultiValueLabel,
      Menu: this.Menu
    };
    if (this.state && this.state.selectedValues && this.state.selectedValues.length > (this.props.maxToDisplay || 3)) {
      selectConfig = Object.assign(selectConfig, {
        MultiValue: this.MultiValue
      });
    }
    return react_1.default.createElement(react_select_1.default, {
      className: 'vdl-multiselect-dropdown',
      blurInputOnSelect: blurInputOnSelect,
      components: selectConfig,
      classNamePrefix: 'vdl',
      placeholder: placeholder || 'Select...',
      options: options,
      optionTerm: optionTerm,
      name: name,
      id: id,
      inputId: inputId,
      isDisabled: isDisabled,
      isLoading: isLoading,
      isMulti: true,
      controlShouldRenderValue: controlShouldRenderValue,
      maxToDisplay: maxToDisplay || 3,
      onChange: function onChange(selected, action) {
        _this.setState({
          selectedValues: selected
        }, function () {
          return _onChange && _onChange(_this.state.selectedValues, action);
        });
      },
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      onInputChange: this.onInputChange,
      onKeyDown: this.onKeyDown,
      onMenuOpen: this.onMenuOpen,
      onMenuClose: this.onMenuClose,
      onMenuScrollToTop: this.onMenuScrollToTop,
      onMenuScrollToBottom: this.onMenuScrollToBottom,
      openMenuOnFocus: openMenuOnFocus,
      openMenuOnClick: openMenuOnClick,
      menuPortalTarget: menuPortalTarget,
      tabIndex: tabIndex,
      tabSelectsValue: tabSelectsValue,
      theme: theme,
      isSearchable: isSearchable,
      minMenuHeight: minMenuHeight,
      maxMenuHeight: maxMenuHeight,
      menuPlacement: menuPlacement,
      menuPosition: menuPosition,
      menuShouldBlockScroll: menuShouldBlockScroll,
      noOptionsMessage: noOptionsMessage,
      value: this.state.selectedValues,
      hideSelectedOptions: false,
      closeMenuOnSelect: false,
      styles: styles
    });
  };
  return MultiSelectDropdown;
}(react_1.default.Component);
exports.MultiSelectDropdown = MultiSelectDropdown;